if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        if($(this).hasClass("cart-drawer-product-form")){
          console.log("condition")
          $(".free_product_add_to_cart").attr("disabled", "disabled");
        }
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
            
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

             /* Add this code to the cart change event in theme */
            setTimeout(function() {
              if(document.querySelectorAll('.block__drawer-gift-product-item-active:not(.deactive)')){
            let upchargeItems = [];
            document.querySelectorAll('.block__drawer-gift-product-item-active:not(.deactive)')?.forEach(function(button) {
              upchargeItems.push({
                id: button.getAttribute("data_id"),
                quantity: 1
              });
            });
    
            let formData = {
                'items': upchargeItems
              };
    
            if(upchargeItems.length){
              fetch('/cart/add.js', {
              body: JSON.stringify(formData),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'xmlhttprequest'
              },
              method: 'POST'
            })
            .then(response => response.json())
            .then(json => {
                 fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
                  .then((response) => response.text())
                  .then((responseText) => {
                      const cartid = 'CartDrawer';
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const destination = document.querySelector('#CartDrawer');
                      const source = html.getElementById(cartid);
                
                  if (source && destination) {
                      destination.innerHTML = source.innerHTML;
                  }
                
                  fetch('/?section_id=cart-icon-bubble')
                  .then((response) => response.text())
                  .then((itemcount) => {
                      const cartIconBubble = document.querySelector('#cart-icon-bubble');
                      if (cartIconBubble) {
                          cartIconBubble.innerHTML = itemcount; 
                          const drawer = document.querySelector('.drawer');
                          if (drawer) {
                              drawer.classList.remove('is-empty');
                          }
                      }
                  })
                  .catch((error) => {
                      console.error('Error fetching cart icon bubble:', error);
                  });
                  })
                  .catch((error) => {
                      console.error('Error updating cart:', error);
                  });
            })
            .catch(err => {
              console.error('Error adding product to cart:', err);
            });
          }
        }
              }, 500);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}